<script setup>
import { ref } from 'vue';

const imageGetahRefs = ref([]);
const imageRefs = ref([]);

// Image data
const products = [
  {
    title: '3 Kaki - 10 Bulan',
    src: new URL('../../Products/Sawit/Sawit_3_kaki.jpeg', import.meta.url).href,
  },
  {
    title: '3.5 Kaki - 11 Bulan',
    src: new URL('../../Products/Sawit/Sawit_3.5_kaki.jpeg', import.meta.url).href,
  },
  {
    title: '3.5 Kaki - 11 Bulan',
    src: new URL('../../Products/Sawit/Sawit_3.5_kaki_2.jpeg', import.meta.url).href,
  },
  {
    title: '4 Kaki - 12 Bulan',
    src: new URL('../../Products/Sawit/Sawit_4_kaki.jpeg', import.meta.url).href,
  },
  {
    title: '4 Kaki - 12 Bulan',
    src: new URL('../../Products/Sawit/Sawit_4_kaki_2.jpeg', import.meta.url).href,
  },
  {
    title: '5 Kaki - 13 Bulan',
    src: new URL('../../Products/Sawit/Sawit_5_kaki.jpeg', import.meta.url).href,
  },
  {
    title: '5 Kaki - 13 Bulan',
    src: new URL('../../Products/Sawit/Sawit_5_kaki_2.jpeg', import.meta.url).href,
  },
  {
    title: '6 Kaki - 14 Bulan',
    src: new URL('../../Products/Sawit/Sawit_6_kaki.jpeg', import.meta.url).href,
  },
  {
    title: '6 Kaki - 14 Bulan',
    src: new URL('../../Products/Sawit/Sawit_6_kaki_2.jpeg', import.meta.url).href,
  }
];

const productsGetah = [
  {
    title: '2 Tingkat',
    src: new URL('../../Products/Getah/Getah_2_tingkat_2.jpeg', import.meta.url).href,
  },
  {
    title: '2 Tingkat',
    src: new URL('../../Products/Getah/Getah_2_tingkat_1.jpeg', import.meta.url).href,
  },
];

// View image in new tab
function viewImage(index) {
  const image = imageRefs.value[index];
  if (image) window.open(image.src, '_blank');
}

// Download image
function downloadImage(index) {
  const image = imageRefs.value[index];
  if (!image) return;

  const link = document.createElement('a');
  link.href = image.src;
  link.download = image.src.split('/').pop(); // optional: use product.title + ".jpg"
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


// View image in new tab
function viewImageGetah(index) {
  const image = imageGetahRefs.value[index];
  if (image) window.open(image.src, '_blank');
}

// Download image
function downloadImageGetah(index) {
  const image = imageGetahRefs.value[index];
  if (!image) return;

  const link = document.createElement('a');
  link.href = image.src;
  link.download = image.src.split('/').pop(); // optional: use product.title + ".jpg"
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
// function downloadImage() {
//   const imageUrl = imageRef.value?.src;
//   if (!imageUrl) return;

//   const link = document.createElement('a');
//   link.href = imageUrl;
//   link.download = imageUrl.split('/').pop(); // e.g., Sawit_3_kaki.jpeg
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

// function viewImage() {
//   const imageUrl = imageRef.value?.src;
//   if (!imageUrl) return;
//   window.open(imageUrl, '_blank');
// }
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12"> 
                <div class="py-3 container-fluid">
                    <div class="row">
                        <div class="col-md-3 mb-2">
                            <div class="card h-100 d-flex flex-column text-center py-3">
                                <h3 for="example-text-input" class="form-control-label">Getah</h3>
                                <span class="text-xs ">Last update: 20-03-25</span>
                                <br />
                                <h6>
                                    1 Tingkat: <br><span style="color:red">RM 3.5</span><br>
                                    2 Tingkat: <br><span style="color:red">RM 4.0</span><br>
                                    3 Tingkat: <br><span style="color:red">RM 4.5</span><br>
                                    4 Tingkat: <br><span style="color:red">RM 5.5</span><br>
                                    5 Tingkat: <br><span style="color:red">RM 6.0</span>
                                </h6>
                            </div>
                        </div>
                        <div class="col-md-3 mb-2">
                            <div class="card h-100 d-flex flex-column text-center py-3">
                                <h3 for="example-text-input" class="form-control-label">Sawit</h3>
                                <span class="text-xs ">Last update: 20-03-25</span>
                                <br />
                                <h6>
                                    2.5 Kaki: <br><span style="color:red">RM 13</span><br>
                                    3 Kaki: <br><span style="color:red">RM 14</span><br>
                                    4 Kaki: <br><span style="color:red">RM 15</span><br>
                                    5 Kaki: <br><span style="color:red">RM 18</span><br>
                                    6 Kaki: <br><span style="color:red">RM 22</span>
                                </h6>
                            </div>
                        </div><div class="col-md-3 mb-2">
                            <div class="card h-100 d-flex flex-column text-center py-3">
                                <h3 for="example-text-input" class="form-control-label">Durian</h3>
                                <span class="text-xs ">Last update: 20-03-25</span>
                                <br />
                                <h6>
                                    Duri Hitan 3Kaki: <br><span style="color:red">RM 30</span><br>
                                    Duri Hitan 3Kaki atas: <br><span style="color:red">RM 35</span><br>
                                    Musang King 3Kaki: <br><span style="color:red">RM 25</span><br>
                                    Musang King 3Kaki atas: <br><span style="color:red">RM 30</span>
                                </h6>
                            </div>
                        </div><div class="col-md-3 mb-2">
                            <div class="card h-100 d-flex flex-column text-center py-3">
                                <h3 for="example-text-input" class="form-control-label">Baja</h3>
                                <span class="text-xs ">Last update: 20-03-25</span>
                                <br />
                                <h6>
                                    Baja NK(15/30): <br><span style="color:red">RM 80/Beg</span><br>
                                    Tai Ayam: <br><span style="color:red"> RM 1000/Tonne</span>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="mt-4 row">
        <div class="col-12"> 
            <div class="card">
                <div class="card-header pb-0">
                    <h4>Sawit</h4>
                </div>
                <div class="row">
                    <div
                        v-for="(product, index) in products"
                        :key="index"
                        class="col-md-3"
                        style="text-align: center;"
                        >
                        <h6>{{ product.title }}</h6>
                        <img
                            :ref="el => imageRefs[index] = el"
                            :src="product.src"
                            :alt="product.title"
                            style="width: 200px; height: auto; margin-bottom: 3px;"
                        />
                        <div class="row">
                            <div class="col-md-12">
                            <button class="btn btn-success" @click="viewImage(index)">View</button>
                            <button class="btn btn-primary" @click="downloadImage(index)">Download</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            
        </div>
    </div>
    <div class="mt-4 row">
        <div class="col-12"> 
            <div class="card">
                <div class="card-header pb-0">
                    <h4>Getah</h4>
                </div>
                <div class="row">
                    <div
                        v-for="(product, index) in productsGetah"
                        :key="index"
                        class="col-md-3"
                        style="text-align: center;"
                        >
                        <h6>{{ product.title }}</h6>
                        <img
                            :ref="el => imageGetahRefs[index] = el"
                            :src="product.src"
                            :alt="product.title"
                            style="width: 200px; height: auto; margin-bottom: 3px;"
                        />
                        <div class="row">
                            <div class="col-md-12">
                            <button class="btn btn-success" @click="viewImageGetah(index)">View</button>
                            <button class="btn btn-primary" @click="downloadImageGetah(index)">Download</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>

<!-- 
<script>
// import axios from 'axios';

export default {
  name:'GalleryImage',
  data(){
    return {
    }
  },
  computed: {
  },
  mounted(){
  },
  methods: { 
    shareOnWhatsApp() {
        const text = encodeURIComponent(`Check out this image: ${imageUrl}`);
        const url = `https://wa.me/?text=${text}`;
        window.open(url, '_blank');
    }
  },
}
</script> -->